module.exports = __webpack_public_path__ + "static/img/8.3f762e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/eng/8.png
// module id = cSFl
// module chunks = 0